import { useEffect, useState } from 'react';
import axiosInstant from '../../api';
import { adminAttributes } from '../../api/endpoints';
import { IAttribute } from '../../pages/admin/attributes/constants';

// The attribute catalog (top-level attribute groups + their values) is small and
// static across a session, so cache it module-side and dedupe concurrent loads —
// every attribute-options selector/modal shares one fetch.
let cache: IAttribute[] | null = null;
let inflight: Promise<IAttribute[]> | null = null;

async function fetchCatalog(): Promise<IAttribute[]> {
  if (cache) return cache;
  if (!inflight) {
    inflight = axiosInstant
      .get(adminAttributes)
      .then((r) => {
        const all: IAttribute[] = r.data || [];
        cache = all
          .filter((a) => a.parent_id == null && (a.values?.length ?? 0) > 0)
          .sort((a, b) => a.order - b.order);
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export const useAttributeCatalog = () => {
  const [attributes, setAttributes] = useState<IAttribute[]>(cache || []);
  const [loading, setLoading] = useState<boolean>(!cache);

  useEffect(() => {
    let active = true;
    if (cache) {
      setAttributes(cache);
      setLoading(false);
    } else {
      setLoading(true);
      fetchCatalog()
        .then((a) => {
          if (active) {
            setAttributes(a);
            setLoading(false);
          }
        })
        .catch(() => {
          if (active) setLoading(false);
        });
    }
    return () => {
      active = false;
    };
  }, []);

  return { attributes, loading };
};
